module.exports = __webpack_public_path__ + "static/img/banner_solutions_access.f1a1a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_access.png
// module id = YZp+
// module chunks = 10